var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepByStepOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "-2.5 -4 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 16.5V15.5H2.6665V15H1.6665V14H2.6665V13.5H0.666504V12.5H3.6665V16.5H0.666504ZM5.6665 15.5V13.5H18.6665V15.5H5.6665ZM0.666504 10.5V9.6L2.4665 7.5H0.666504V6.5H3.6665V7.4L1.8665 9.5H3.6665V10.5H0.666504ZM5.6665 9.5V7.5H18.6665V9.5H5.6665ZM1.6665 4.5V1.5H0.666504V0.5H2.6665V4.5H1.6665ZM5.6665 3.5V1.5H18.6665V3.5H5.6665Z",
    fill: "#090C10",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepByStepOff);
export default __webpack_public_path__ + "static/media/stepByStepOff.ff8b3de5adeb2b5fa84c03b22c559f64.svg";
export { ForwardRef as ReactComponent };